import styled, { keyframes } from "styled-components";

const slideDown = keyframes`
  from { opacity: 0; transform: translateY(-8px); }
  to   { opacity: 1; transform: translateY(0); }
`;

export const AlertBannerStack = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 12px 16px 0;

  @media (max-width: 768px) {
    padding: 8px 12px 0;
  }
`;

/**
 * Tone drives the left rail colour only. Rework is the one that means
 * "you have unfinished work", so it reads as a warning; approvals are
 * good news and stay green; assignments are neutral-informational.
 * Urgent (Matthew, 2026-08-11) is the one the assigner chose by hand,
 * so it reads the loudest -- red, not amber.
 */
const toneColors = {
  urgent_task: { rail: "#dc2626", bg: "#fef2f2", border: "#fecaca" },
  rework_requested: { rail: "#d97706", bg: "#fffbeb", border: "#fde68a" },
  assigned: { rail: "#2563eb", bg: "#eff6ff", border: "#bfdbfe" },
  approved: { rail: "#059669", bg: "#ecfdf5", border: "#a7f3d0" },
};

export const AlertCard = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 12px 14px;
  border-radius: 8px;
  border: 1px solid ${({ $tone }) => (toneColors[$tone] || toneColors.approved).border};
  background: ${({ $tone }) => (toneColors[$tone] || toneColors.approved).bg};
  border-left: 4px solid ${({ $tone }) => (toneColors[$tone] || toneColors.approved).rail};
  animation: ${slideDown} 180ms ease-out;
`;

export const AlertIconSlot = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  margin-top: 1px;
  color: ${({ $tone }) => (toneColors[$tone] || toneColors.approved).rail};
`;

export const AlertBody = styled.div`
  flex: 1;
  min-width: 0;
`;

export const AlertTitle = styled.div`
  font-size: 14px;
  font-weight: 600;
  color: #111827;
  line-height: 1.35;
`;

export const AlertMeta = styled.div`
  font-size: 12px;
  color: #4b5563;
  margin-top: 2px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const AlertActions = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  flex-shrink: 0;
`;

export const AlertLinkButton = styled.button`
  background: none;
  border: none;
  padding: 4px 8px;
  font-size: 13px;
  font-weight: 600;
  color: #1d4ed8;
  cursor: pointer;
  border-radius: 4px;

  &:hover {
    background: rgba(29, 78, 216, 0.08);
  }
`;

export const AlertDismissButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  background: none;
  border: none;
  padding: 4px;
  cursor: pointer;
  color: #6b7280;
  border-radius: 4px;

  &:hover {
    background: rgba(0, 0, 0, 0.06);
    color: #111827;
  }
`;

export const AlertRollup = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 8px 14px;
  border-radius: 8px;
  border: 1px solid #e5e7eb;
  background: #f9fafb;
  font-size: 13px;
  color: #374151;
`;
